import React, { FunctionComponent } from 'react';
import { ErrorAlert } from '../ErrorAlert';
import { AppHead } from '../AppHead';

interface ErrorWithHeaderProps {
  title: string;
  message: string;
}

// ErrorWithHeader is a component that displays an error message with the app header in a consistent layout.
export const ErrorWithHeader: FunctionComponent<ErrorWithHeaderProps> = ({ title, message }) => {
  return (
    <div className="relative min-h-screen">
      <AppHead />
      <div className="flex min-h-screen items-center justify-center p-4 pt-10">
        <ErrorAlert 
          title={title} 
          message={message} 
        />
      </div>
    </div>
  );
};
